import React from 'react'
import Team from '../components/Team';
import Contact from '../components/Contact';
import AboutUsSection from '../components/AboutSection';
import SEOHead from '../components/SEOHead';

const AboutPage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About Codewave Technologies Limited - Leading ICT Company in Kenya",
    "description": "Learn about Codewave Technologies Limited's mission, vision, and commitment to providing premier ICT and telecom solutions in Kenya. Trusted ICT services provider in Nairobi.",
    "url": "https://www.codewave.co.ke/about",
    "mainEntity": {
      "@type": "Organization",
      "name": "Codewave Technologies Limited",
      "legalName": "Codewave Technologies Limited",
      "alternateName": ["Codewave", "Codewave Kenya"],
      "description": "Codewave Technologies Limited is a leading ICT company in Kenya providing telecom solutions, bulk SMS services, USSD service provider, SMS gateway, mobile payment solutions, and API integration services for businesses in Nairobi and across Kenya.",
      "foundingLocation": {
        "@type": "Place",
        "name": "Nairobi, Kenya"
      },
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Nairobi",
        "addressRegion": "Nairobi",
        "addressCountry": "KE"
      },
      "knowsAbout": [
        "ICT company in Kenya",
        "Telecom solutions Kenya",
        "Bulk SMS Kenya",
        "USSD service provider Kenya",
        "SMS gateway Kenya",
        "Mobile payment solutions Kenya",
        "API integration services Kenya"
      ]
    }
  };

  return (
    <>
      <SEOHead
        title="About Codewave Technologies Limited - Leading ICT Company in Kenya | Telecom Solutions Nairobi"
        description="Learn about Codewave Technologies Limited, a leading ICT company in Kenya and trusted telecom company in Nairobi. Discover our journey providing bulk SMS services, USSD solutions, SMS gateway, and mobile payment solutions to businesses across Kenya."
        keywords="Codewave Technologies Limited, about Codewave, ICT company in Kenya, ICT services Nairobi, telecom company Nairobi Kenya, Kenyan ICT solutions provider, telecom solutions Kenya, bulk SMS Nairobi, USSD services Nairobi, mobile payment solutions Kenya, business communication solutions, enterprise messaging solutions"
        url="https://www.codewave.co.ke/about"
        canonical="https://www.codewave.co.ke/about"
        structuredData={structuredData}
      />
      <AboutUsSection />
      <Team />
      <Contact />
    </>
  )
}

export default AboutPage